import { jsxs as F, jsx as e } from "react/jsx-runtime";
import n from "react";
import V from "classnames";
import p from "lodash/fp/noop";
import { selectIconColor as q } from "./index.es776.js";
import { Button as I } from "./index.es15.js";
import t from "./index.es777.js";
import { getComponentDisplayName as G } from "./index.es726.js";
import { Dropdown as J } from "./index.es72.js";
import { CascadingMenu as K } from "./index.es81.js";
import { BasicDropdownMenu as Q } from "./index.es73.js";
import { UtilityChevronIcon as W } from "./index.es439.js";
const X = "split-button-component";
function Y(o) {
  return "subItems" in o[0] && Array.isArray(o[0].subItems);
}
const Z = {
  "secondary-blue": "primary-brand",
  "secondary-gray": "default-gray",
  "primary-brand": "white",
  "primary-ghost": "primary-brand",
  "primary-gray": "white"
}, k = 200, po = n.forwardRef(
  ({
    variant: o,
    items: m,
    fullWidth: d,
    testId: r = X,
    LeftIcon: M,
    children: u,
    Icon: c,
    disabled: _,
    size: l = "default",
    side: w = "bottom",
    align: E = "center",
    menuWidth: f = k,
    appendToParent: S,
    parentElement: T,
    buttonRef: D,
    alignOffset: L,
    sideOffset: $,
    classname: v,
    onItemSelection: g = p,
    onClick: a = p,
    ...y
  }, C) => {
    const [N, b] = n.useState(!1), [O, B] = n.useState(!1), U = Y(m), A = {
      color: "outline",
      outline: q(o, !!_)
    }, i = !!c, H = V(
      t.triggerRoot,
      t[`button-${o}`],
      t[l],
      v,
      {
        [t[`hover-${o}`]]: N,
        [t.fullWidth]: d,
        [t.isIcon]: i
      }
    ), P = () => {
      b(!0);
    }, R = () => {
      b(!1);
    }, x = n.useCallback(
      (s) => {
        s.stopPropagation(), a == null || a(s);
      },
      [a]
    );
    return /* @__PURE__ */ F(
      "div",
      {
        className: H,
        onMouseEnter: P,
        onMouseLeave: R,
        "data-testid": r,
        ref: C,
        children: [
          /* @__PURE__ */ e(
            I,
            {
              testId: `${r}-action-button`,
              "aria-label": `split-button-${i ? G(c) : `-${u}`}`,
              ...y,
              variant: o,
              fullWidth: d,
              ref: D,
              LeftIcon: i ? void 0 : M,
              size: l,
              onClick: x,
              children: i ? n.cloneElement(c, A) : u
            }
          ),
          /* @__PURE__ */ e(
            J,
            {
              open: O,
              setOpen: B,
              closeOnSelection: !0,
              testId: `${r}-dropdown`,
              side: w,
              align: E,
              appendToParent: S,
              parentElement: T,
              triggerMerge: !0,
              trigger: /* @__PURE__ */ e(
                I,
                {
                  testId: `${r}-inner-dropdown-trigger`,
                  ...y,
                  variant: o,
                  size: l,
                  children: /* @__PURE__ */ e(
                    W,
                    {
                      "data-testid": "chevron-icon",
                      outline: Z[o || "primary-gray"],
                      type: "bold"
                    }
                  )
                }
              ),
              alignOffset: L,
              sideOffset: $,
              children: /* @__PURE__ */ e("div", { style: { width: f }, children: U ? /* @__PURE__ */ e(
                K,
                {
                  testId: r + "-cascading-menu",
                  items: m.map((s) => {
                    var h;
                    return {
                      ...s,
                      isSelected: !1,
                      subItems: (h = s.subItems) == null ? void 0 : h.map((j) => ({
                        ...j,
                        isSelected: !1
                      }))
                    };
                  }),
                  onItemSelection: g,
                  setItems: p,
                  menuWidth: f
                }
              ) : /* @__PURE__ */ e(Q, { items: m, onItemSelection: g }) })
            }
          )
        ]
      }
    );
  }
);
export {
  po as PrimitiveSplitButton,
  X as SPLIT_BUTTON_DEFAULT_TEST_ID
};
//# sourceMappingURL=index.es12.js.map
